// extracted by mini-css-extract-plugin
export default {"banner-notice":"f07XLFITG_TF5nSIUpCD"};